import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

export const VideoEmbeder = ({videoId}) => {
    const [consent, setConsent] = useState(false);
    const {t} = useTranslation();

    // 1. Check if 'youtube' is accepted via CookieConsent
    const evaluateConsent = useCallback((event) => {
        const categories = event?.detail?.cookie?.categories ?? [];
        const accepted = categories.includes("youtube");
        setConsent(!!accepted);
    }, []);

    const handleManualConsent = () => {
        // 2. Manually accept 'youtube' category
        window.CookieConsent?.acceptCategory?.('youtube');
        setConsent(true);
    };

    useEffect(() => {
        window.addEventListener('cc:onFirstConsent', evaluateConsent, { passive: true });
        window.addEventListener('cc:onConsent', evaluateConsent, { passive: true });
        window.addEventListener('cc:onChange', evaluateConsent, { passive: true });

        return () => {
            window.removeEventListener('cc:onFirstConsent', evaluateConsent);
            window.removeEventListener('cc:onConsent', evaluateConsent);
            window.removeEventListener('cc:onChange', evaluateConsent);
        };
    }, [evaluateConsent]);

    if (!consent) {
        return (
            <div className="container text-center py-4 rounded">
                <p className="mb-3">{t('pages.common.videoEmbeder.consentRequired')}</p>
                <button className="btn btn-secondary" onClick={handleManualConsent}>
                    {t('pages.common.videoEmbeder.acceptButton')}
                </button>
            </div>
        );
    }

    if (!videoId) {
        return <div className="alert alert-warning">{t('pages.common.videoEmbeder.noVideo')}</div>;
    }

    return (
        <div className="container">
            <div className="ratio ratio-16x9">
                <iframe
                    src={`https://www.youtube-nocookie.com/embed/${videoId}`}
                    title="YouTube video"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                ></iframe>
            </div>
        </div>
    );
};
